<template lang='pug'>
  .who-we-serve
    another-arch
    v-row(justify='center')
      v-col(cols='12' md='10' lg='8' xl='6')
        v-row(align='center' justify='center')
          v-col(cols='10' md='6')
            v-row.pa-5
              div
                .headline.grey--text.text--lighten-2 Development Teams
                .body-1.grey--text.text--lighten-1 Focus on adding value to your end users while we help you move faster with more confidence in that your new value isn't impacting existing functionality.
            v-row.pa-5
              div
                .headline.grey--text.text--lighten-2 Quality Assurance Teams
                .body-1.grey--text.text--lighten-1 Use Bionic Metrics to automate the repetitive tasks for your regression testing so you can focus on acceptance testing, exploratory testing, and feel confident that the quality of your products is excellent.
            v-row.pa-5
              div
                .headline.grey--text.text--lighten-2 Chief Technology Officers
                .body-1.grey--text.text--lighten-1 Use Bionic Metrics to monitor the quality of your development, staging, test, and production stacks and avoid costly bugs, support spikes, and ensure the fastest possible development velocity.
          //v-col(cols='10' md='6')
            blockquote
              p
                | Just wanted to share with you all, our release is out and how amazing our automation tests have been and continue to serve...Thanks!
                .testimonial-author-name Mary W.
                .testimonial-author-title bulb


</template>

<script>
import AnotherArch from './AnotherArch';

export default {
  name: 'WhoWeServe',
  components: {AnotherArch},
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.mdAndDown;
    }
  },
  data() {
    return {};
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .who-we-serve {
    background-color: #546E7A;
    padding-bottom: 4vh;
  }

  blockquote {
    background: #f9f9f9;
    border-left: 10px solid #ccc;
    margin: 1.5em 10px;
    padding: 0.5em 10px;
  }

</style>
